// extracted by mini-css-extract-plugin
module.exports = {"card":"_d2b0a444","message":"_d779bbc5","button":"_66eb009c","footnote":"_ec93f7b0"};